import actionTypes from './actionTypes';
import { ProductTypeApi } from '../../api/productType';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

const api = new ProductTypeApi();

export const loadProductTypes =  () => async dispatch => {
    try{
        dispatch({type: actionTypes.LOAD_PRODUCT_TYPES_START, payload: {}});
        
        const {data} = await api.getProductTypesList();

        return dispatch({type: actionTypes.LOAD_PRODUCT_TYPES_SUCCESS, payload: {data}});

    }catch(error){
        return dispatch({type: actionTypes.LOAD_PRODUCT_TYPES_FAIL, payload: {error}});
    }
};